import { render, staticRenderFns } from "./ScreenDetails.vue?vue&type=template&id=62e48082&"
import script from "./ScreenDetails.vue?vue&type=script&lang=ts&"
export * from "./ScreenDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports